import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "squares.2.dotted", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("rect", { width: 7, height: 7, x: 6.5, y: 6.5, rx: 0.75 }),
        React.createElement("path", { d: "M3.5 5v-.75a.75.75 0 0 1 .75-.75H5m1 0h2m1 0h.75a.75.75 0 0 1 .75.75V5m-7 1v2m0 1v.75c0 .414.336.75.75.75H5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
